import React from "react";
import { Link } from "react-router-dom";
import { RoutesPaths } from "../Router/Constant";
import { useLanguage } from "../Router/LanguageContext";

export default function Footer() {
  // const [isOpen, setIsOpen] = useState(false);
  // const dropdownRef = useRef();
  const { dictionary } = useLanguage();
  // const { dictionary, changeLanguage, lang } = useLanguage();

  // const languages = [
  //   { code: "en", label: "English", img: "/assets/img/english.svg" },
  //   { code: "pg", label: "Portuguese", img: "/assets/img/Portuguese.svg" },
  //   { code: "fr", label: "French", img: "/assets/img/French.svg" },
  // ];

  // const selected = languages.find((l) => l.code === lang);

  // useEffect(() => {
  //   const handleClickOutside = (e) => {
  //     if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
  //       setIsOpen(false);
  //     }
  //   };

  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, []);

  return (
    <div className="outerFooterSection EllipseIconRelative">
      <div className="footerHeaderShade">
        <img src="/assets/img/footerHeaderShade.png" alt="" />
      </div>
      <div className="container-fluid maxContainerSection footerRowSection">
        <div className="row">
          <div className="col-md-5 footerLeftOuterSection">
            <div className="footerLeftSection">
              <Link to={RoutesPaths.LANDING}>
                <img
                  src="/assets/img/quimenergylogoWhite.svg"
                  alt=""
                  className="footerLogo"
                />
              </Link>
              <p className="m-0 f-s-20 footerDesc">{dictionary?.footertitle}</p>
            </div>

            {/* <div className="">
              <div className="" ref={dropdownRef}>
                <div
                  className="selectLanguage"
                  onClick={() => setIsOpen(!isOpen)}
                >
                  <img src={selected?.img} alt="" />
                  <p className="m-0">{selected?.label}</p>
                  <img src="/assets/img/downIcon.svg" alt="" />
                </div>

                {isOpen && (
                  <div className="optionlanguageOuter show">
                    {languages.map((item) => (
                      <div
                        key={item.code}
                        className={`optionlanguage ${
                          lang === item.code ? "active" : ""
                        }`}
                        onClick={() => {
                          changeLanguage(item.code);
                          setIsOpen(false); // ✅ added
                        }}
                      >
                        <img src={item.img} alt="" />
                        <p className="m-0">{item.label}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div> */}
          </div>

          <div className="col-md-7">
            <div className="row">
              <div className="col-6 col-md-4 col-sm-6">
                <div>
                  <div className="rightFooterLinksHeader">
                    <h6 className="m-0">{dictionary?.usefulLinks}</h6>
                    <div className="headerFooterLine"></div>
                  </div>
                  <div className="rightFooterLinks">
                    <img src="/assets/img/arrowIcon.svg" alt="" />
                    <Link to={RoutesPaths.LANDING}>
                      <p className="m-0">{dictionary?.home}</p>
                    </Link>
                  </div>

                  <div className="rightFooterLinks">
                    <img src="/assets/img/arrowIcon.svg" alt="" />
                    <Link to={RoutesPaths.ABOUTUS}>
                      <p className="m-0">{dictionary?.aboutUs}</p>
                    </Link>
                  </div>

                  <div className="rightFooterLinks">
                    <img src="/assets/img/arrowIcon.svg" alt="" />
                    <Link to={RoutesPaths.ESG}>
                      <p className="m-0">{dictionary?.esg}</p>
                    </Link>
                  </div>

                  <div className="rightFooterLinks">
                    <img src="/assets/img/arrowIcon.svg" alt="" />
                    <Link to={RoutesPaths.CONTACTUS}>
                      <p className="m-0">{dictionary?.contactUs}</p>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-6 col-md-4 col-sm-6">
                <div>
                  <div className="rightFooterLinksHeader">
                    <h6 className="m-0">{dictionary?.ourSolutions}</h6>
                    <div className="headerFooterLine"></div>
                  </div>
                  <div className="rightFooterLinks">
                    <img src="/assets/img/arrowIcon.svg" alt="" />
                    <Link to={RoutesPaths.RENEWABLEENERGY}>
                      <p className="m-0">{dictionary?.renewableEnergy}</p>
                    </Link>
                  </div>

                  <div className="rightFooterLinks">
                    <img src="/assets/img/arrowIcon.svg" alt="" />
                    <Link to={RoutesPaths.OILGAS}>
                      <p className="m-0">{dictionary?.oilAndGas}</p>
                    </Link>
                  </div>

                  <div className="rightFooterLinks">
                    <img src="/assets/img/arrowIcon.svg" alt="" />
                    <Link to={RoutesPaths.EPC}>
                      <p className="m-0">{dictionary?.epcInfrastructure}</p>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-4 col-sm-6 col-contact-info">
                <div>
                  <div className="rightFooterLinksHeader">
                    <h6 className="m-0">{dictionary?.contactInformation}</h6>
                    <div className="headerFooterLine"></div>
                  </div>
                  <div className="rightFooterLinks">
                    <img src="/assets/img/phoneIcon.svg" alt="" />
                    <p className="m-0">
                      <a href="tel:+244973088141">+244 973 088 141</a>
                      <br />
                      <a href="tel:+244947885958">+244 947 885 958</a>
                    </p>
                  </div>

                  <div className="rightFooterLinks">
                    <img src="/assets/img/emailIcon.svg" alt="" />
                    <p className="m-0">
                      <a href="mailto:Geral@quimenergy.ao">
                        Geral@quimenergy.ao
                      </a>
                    </p>
                  </div>

                  <div className="rightFooterLinks">
                    <img src="/assets/img/locationIcon.svg" alt="" />
                    <p className="m-0">
                      Edifício Ingombota Palace, 3º Andar, Luanda
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="socialLinksOuter">
                  <div className="socialLinks">
                    <img src="/assets/img/Facebook.svg" alt="" />
                    <p className="m-0 f-s-16">{dictionary?.facebook}</p>
                  </div>
                  <div className="socialLinks">
                    <img src="/assets/img/Twitter.svg" alt="" />
                    <p className="m-0 f-s-16">X</p>
                  </div>
                  <div className="socialLinks">
                    <img src="/assets/img/instagram.svg" alt="" />
                    <p className="m-0 f-s-16">{dictionary?.instagram}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid maxContainerSection copyRightSection">
        <div className="row">
          <div className="col-md-12 CopyrightFooter">
            <div>
              <p className="m-0 copyrightText">
                Ⓒ {dictionary?.copyright} Quimenergy {new Date().getFullYear()}.{" "}
                {dictionary?.allrightreserved}.
              </p>
            </div>
            <div className="policyCondition">
              <p className="m-0">
                <Link
                  to={RoutesPaths.PRIVACYPOLICY}
                  className="text-decoration-none text-dark"
                >
                  {dictionary?.privacyPolicy}
                </Link>
              </p>
              <p className="m-0">
                <Link
                  to={RoutesPaths.TERMSCONDITIONS}
                  className="text-decoration-none text-dark"
                >
                  {dictionary?.termsConditions}
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
      <img src="/assets/img/Ellipse.png" alt="" className="EllipseIcon" />
    </div>
  );
}
